import { useMutation } from '@tanstack/react-query';

import { useSession } from '@/entities/session';
import { setAccessToken, useTRPC } from '@/shared/api';

/**
 * 로그아웃.
 *
 * **서버에 반드시 알린다.** 화면 상태만 비우면 리프레시 쿠키(14일)와 Redis 세션이 그대로
 * 살아 있어서, 새로고침 한 번이면 앱 부팅의 세션 복구가 도로 로그인시킨다 —
 * 공용 PC 에서는 다음 사람이 그 계정을 그대로 이어받는다.
 *
 * 화면을 **먼저** 비우는 이유: 응답을 기다리는 동안 로그인된 화면이 남아 있으면,
 * 그 사이의 클릭이 이미 끝난 세션으로 나간다. 서버가 필요로 하는 것은 쿠키의
 * 리프레시 토큰이지 액세스 토큰이 아니라, 먼저 비워도 로그아웃은 성립한다.
 *
 * 실패를 화면에 알리지 않는다 — 사용자가 할 수 있는 일이 없고, 서버는 실패해도 쿠키를
 * 지운다(`auth.router.ts` 의 finally). 응답이 서버까지 닿지 못한 경우(네트워크 단절)에만
 * 세션이 남는데, 그건 이 훅이 없던 때와 같은 상태이지 새로 나빠지는 것이 아니다.
 */
export function useSignOut(): () => void {
  const trpc = useTRPC();
  const clearSession = useSession((state) => state.signOut);
  const { mutateAsync } = useMutation(trpc.auth.signout.mutationOptions());

  return () => {
    setAccessToken(null);
    clearSession();
    void mutateAsync().catch(() => undefined);
  };
}
